'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bg_BG = require('../locale/bg_BG');

var _bg_BG2 = _interopRequireDefault(_bg_BG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _bg_BG2['default'];